"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var createRecord_1 = require("./createRecord");
var preventEvents_1 = require("../utils/preventEvents");
var navigate = function (openInNewWindow, url) {
    if (!window)
        return;
    if (openInNewWindow)
        return window.open(url, '_blank');
    return window.location.href = url;
};
var Item = (function (_super) {
    __extends(Item, _super);
    function Item(value, meta, analytics) {
        var _this = _super.call(this, value) || this;
        _this.onClick = function (e) {
            preventEvents_1.preventEvents(e);
            var openInNewWindow = e && (e.ctrlKey || e.metaKey);
            _this.analytics.sendEvent('click-item', { rid: _this.meta.get('rid'), item_id: _this.get('id') }, !openInNewWindow);
            navigate(openInNewWindow, _this.get('product_url'));
        };
        _this.meta = meta;
        _this.analytics = analytics;
        return _this;
    }
    ;
    return Item;
}(createRecord_1.default('Item')));
exports.Item = Item;
//# sourceMappingURL=item.js.map